import React from 'react';
import { injectIntl } from 'react-intl';
import { InfoBox, Box } from '@landtrustinc/design-system';
import useLodgingFeatures from '../../hooks/useLodgingFeatures';

const SectionAddons = ({ campsites, lodging, lodgingPricesOptions, intl }) => {
  const { features } = useLodgingFeatures({
    campsites,
    lodging,
    lodgingPricesOptions,
    intl,
    filterBy: 'optional',
  });

  if (!features || features.length === 0) {
    return null;
  }

  return (
    <Box mb="var(--spacing-5)">
      <InfoBox
        heading={intl.formatMessage({ id: 'ListingPage.optionalAddonsTitle' })}
        features={features}
      />
    </Box>
  );
};

export default injectIntl(SectionAddons);
